<script setup>
import { useColorMode } from "@vueuse/core";
import { computed, ref, watch } from "vue";

const mode = useColorMode({
  initialValue: "dark",
});

const logo = computed(() =>
  mode.value === "light"
    ? "/assets/images/Knocknoc_long_whitebg_Large_purple.png"
    : "/assets/images/Knocknoc_long_darkbg_Large_purple.png",
);
const needsDarkBackground = ref(false);

watch(
  mode,
  async () => {
    const response = await fetch(logo.value);
    needsDarkBackground.value = mode.value === "light" && response.headers.get("X-Logo-Type") === "dark";
  },
  {
    immediate: true,
  },
);
</script>

<template>
  <img :class="{ 'bg-black': needsDarkBackground }" :src="logo" alt="Knocknoc logo" />
</template>
